import React from "react";

export const CarbonCredits = [
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 solidColourContainer">
      <h4 className="slideTitle">
        We help customers compensate their remaining CO<sub>2</sub> emissions.
      </h4>
      <p>
        Our global portfolio of carbon credits provides many benefits including
        risk mitigation, diversity of projects and geographies as well as
        positive impact across many communities and environments. 
      </p>
      <h4 className="slideTitle">We offer:</h4>
      <ul className="shell_bullets_list">
        <li>
          <strong>Bundled carbon credits with Shell products</strong>
          <br />
          We can bundle carbon credits with products you buy from Shell: we
          quantify and compensate the lifecycle CO<sub>2</sub> emissions of the
          product with nature-based carbon credits
        </li>
        <li>
          <strong>Unbundled carbon credits (standalone)</strong>
          <br />
          We can supply stand alone carbon credits (retirements or registry
          transfer) to customers to help you compensate CO<sub>2</sub> emissions from your
          activities.
        </li>
      </ul>
    </div>
    <div className="colRight col50 backgroundImage">
      <img src="images/carbonCredits.jpg" width="100%" height="auto" />
    </div>
  </div>,
  <>
    <h4 className="slideTitle">Shell global Carbon Credit portfolio</h4>
    <div className="slideContainer slide_solidColour">
      <img
        src="images/carbonCredits-map.JPG"
        width="100%"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
  <>
    <h4 className="slideTitle">Compensating your CO<sub>2</sub> emissions with Carbon Credits</h4>
    <div className="slideContainer slide_solidColour">
      <img
        src="images/carbonCredits-circle.JPG"
        width="100%"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
];
